const Settings = () => import('./main.vue')
const AccountForm = () => import('./accountform.vue')
const PlanBilling = () => import('./planbilling.vue')

const meta = {
  requiresAuth: true,
}

const planBillingMeta = {
  requiresAuth: true,
  requiresSignupAdmin: true,
}

export default [
  {
    name: 'settings.index',
    path: '/settings',
    component: Settings,
    meta,
    children: [
      {
        name: 'settings.account',
        path: '/settings/account',
        component: AccountForm,
        meta,
      },
    ],
  },
  {
        name: 'settings.account',
        path: '/settings/account',
        component: AccountForm,
        meta,
      },
  {
    name: 'settings.planbilling',
    path: '/settings/plan-billing',
    component: PlanBilling,
    meta: planBillingMeta,
  },
]
